import Link from 'next/link';
import { ContactUsPageURL } from '@/lib/appConstants';

interface DocsFooterProps {
  showFaq?: boolean;
}

export function DocsFooter({ showFaq = true }: DocsFooterProps) {
  return (
    <p>
      Need help? {showFaq && (
        <>
          Visit our{' '}
          <Link href="/docs/general/faqs" className="text-[var(--accent-primary)] hover:underline">
            Frequently Asked Questions
          </Link>{' '}
          or{' '}
        </>
      )}
      <Link href={ContactUsPageURL} className="text-[var(--accent-primary)] hover:underline">
        Contact Us
      </Link>
      .
    </p>
  );
}
